
import { S3BucketJobseeker } from 'images'


const baseUrl = `${S3BucketJobseeker}/remote_page/images`

export const allImages = new Array(10).fill(1).map((v, i) => {
  return `${baseUrl}/corperate${i + 1}.png`
})
